import { render, staticRenderFns } from "./currencyRedemption.vue?vue&type=template&id=f409181a"
import script from "./currencyRedemption.vue?vue&type=script&lang=js"
export * from "./currencyRedemption.vue?vue&type=script&lang=js"
import style0 from "./currencyRedemption.vue?vue&type=style&index=0&id=f409181a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports